import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/access';
import { DepartmentsPage } from '@/features/department/list-page';

export const Route = createFileRoute('/_authenticated/system/departments')({
  beforeLoad: ({ context, location }) =>
    requirePermission(context.queryClient, location.href, 'departments:read'),
  component: DepartmentsPage,
});
